import {
  Button,
  Modal as ChakraModal,
  Flex,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure
} from '@chakra-ui/react';
import React, { useMemo } from 'react';
import * as yup from 'yup';

const schema = yup.object().shape({
  observacao: yup.string().required('Por favor, digite uma observação')
});

export function ModalLayoutFinalizado({ title, data, buttonName }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  console.log('data', data);

  const listOrderBy = useMemo(() => {
    return data?.sort((a, b) => {
      return b.quantidade - a.quantidade;
    });
  }, [data]);

  return (
    <>
      <Button onClick={onOpen}>{buttonName}</Button>

      <ChakraModal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <TableContainer>
              <Table variant="simple" colorScheme="blackAlpha">
                <TableCaption>{title}</TableCaption>
                <Thead>
                  <Tr>
                    <Th>Nome</Th>
                    <Th isNumeric>Quantidade</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {listOrderBy?.map((item, index) => (
                    <Tr key={index}>
                      <Td position="relative">
                        {item.nome}
                        {index === 0 && (
                          <Flex
                            position="absolute"
                            left="0"
                            top="0"
                            bottom="0"
                            alignItems="center"
                            justifyContent="center"
                            width="100%"
                            height="100%">
                            <Text fontSize="1.5rem" fontWeight="bold" color="green">
                              🏆
                            </Text>
                          </Flex>
                        )}
                        {index === 1 && (
                          <Flex
                            position="absolute"
                            left="0"
                            top="0"
                            bottom="0"
                            alignItems="center"
                            justifyContent="center"
                            width="100%"
                            height="100%">
                            <Text fontSize="1.5rem" fontWeight="bold" color="green">
                              🥈
                            </Text>
                          </Flex>
                        )}
                        {index === 2 && (
                          <Flex
                            position="absolute"
                            left="0"
                            top="0"
                            bottom="0"
                            alignItems="center"
                            justifyContent="center"
                            width="100%"
                            height="100%">
                            <Text fontSize="1.5rem" fontWeight="bold" color="green">
                              🥉
                            </Text>
                          </Flex>
                        )}
                      </Td>
                      <Td isNumeric>{item.quantidade} layouts</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  );
}
